/* Lotte Laren — zijmenu-extra's + live zoekresultaten (foto, naam, prijs) direct onder de zoekbalk */
(function () {
  if (window.__llDrawerExtra) return;
  window.__llDrawerExtra = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Zijmenu ---------- */
  function injectDrawer() {
    var tpl = document.getElementById('ll-drawer-extra');
    if (tpl) {
      document.querySelectorAll('.drawer--header .drawer__content__scroll').forEach(function (scroll) {
        if (scroll.querySelector('[data-ll-dx]')) return;
        scroll.appendChild(tpl.content.cloneNode(true));
      });
    }
  }

  /* ---------- Zoeken ---------- */
  var allProducts = null;
  var allLoading = null;
  var timer = null;
  var lastQuery = '';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function euro(n) {
    n = Number(n) || 0;
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function setupInputs() {
    document.querySelectorAll('.search-popdown input[type="search"]').forEach(function (input) {
      input.setAttribute('placeholder', 'Zoeken');
      var form = input.closest('form');
      if (form && !form.querySelector('[data-ll-sr]')) {
        var box = document.createElement('div');
        box.className = 'll-sr';
        box.setAttribute('data-ll-sr', '');
        box.hidden = true;
        form.appendChild(box);
      }
    });
  }

  function loadAll() {
    if (allProducts) return Promise.resolve(allProducts);
    if (allLoading) return allLoading;
    var list = [];
    function page(p) {
      return fetch(root + 'collections/all/products.json?limit=250&page=' + p, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var items = (data && data.products) || [];
          items.forEach(function (p) {
            var v = (p.variants && p.variants[0]) || {};
            var available = (p.variants || []).some(function (x) { return x.available; });
            list.push({
              title: p.title,
              url: root + 'products/' + p.handle,
              img: p.images && p.images[0] ? p.images[0].src : '',
              price: parseFloat(v.price) || 0,
              compare: parseFloat(v.compare_at_price) || 0,
              available: available,
              hay: norm([p.title, p.product_type, p.vendor, (p.tags || []).join(' ')].join(' '))
            });
          });
          if (items.length === 250 && p < 8) return page(p + 1);
        });
    }
    allLoading = page(1).then(function () { allProducts = list; return list; }).catch(function () { allProducts = list; return list; });
    return allLoading;
  }

  function localSearch(q) {
    return loadAll().then(function (list) {
      var words = norm(q).split(/\s+/).filter(Boolean);
      return list.filter(function (p) {
        var tokens = p.hay.split(/[^a-z0-9]+/);
        return words.every(function (w) {
          return tokens.some(function (t) { return t.indexOf(w) === 0; }) || p.hay.indexOf(w) > -1;
        });
      }).sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
    });
  }

  function suggestSearch(q) {
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        return items.map(function (p) {
          return {
            title: p.title,
            url: (p.url || '').split('?')[0],
            img: p.image || (p.featured_image && p.featured_image.url) || '',
            price: parseFloat(p.price) || 0,
            compare: parseFloat(p.compare_at_price_max) || 0,
            available: p.available !== false
          };
        });
      })
      .catch(function () { return []; });
  }

  function dedupe(items) {
    var seen = {};
    return items.filter(function (p) {
      var key = norm(p.title);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function render(box, q, items) {
    var total = items.length;
    items = dedupe(items).slice(0, 6);
    var html = '';
    if (!items.length) {
      html = '<p class="ll-sr__empty">Geen producten gevonden voor ‘' + esc(q) + '’</p>';
    } else {
      html += '<p class="ll-sr__head">Producten</p>';
      items.forEach(function (p) {
        var sale = p.compare && p.compare > p.price;
        html +=
          '<a class="ll-sr__item" href="' + esc(p.url) + '">' +
            '<span class="ll-sr__img">' + (p.img ? '<img src="' + esc(sized(p.img, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="ll-sr__title">' + esc(p.title) + (p.available ? '' : ' <em>Uitverkocht</em>') + '</span>' +
            '<span class="ll-sr__price">' +
              (sale ? '<s>' + euro(p.compare) + '</s>' : '') +
              '<span class="' + (sale ? 'is-sale' : '') + '">' + euro(p.price) + '</span>' +
            '</span>' +
          '</a>';
      });
    }
    html += '<a class="ll-sr__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last">' +
      'Bekijk alle resultaten' + (total > 6 ? ' (' + total + ')' : '') + ' <span aria-hidden="true">→</span></a>';
    box.innerHTML = html;
    box.hidden = false;
  }

  function runSearch(input) {
    var form = input.closest('form');
    var box = form && form.querySelector('[data-ll-sr]');
    if (!box) return;
    var q = input.value.trim();
    lastQuery = q;
    if (!q) {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }
    box.classList.add('is-loading');
    suggestSearch(q)
      .then(function (items) { return items.length ? items : localSearch(q); })
      .then(function (items) {
        if (q !== lastQuery) return;
        box.classList.remove('is-loading');
        render(box, q, items);
      });
  }

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.search-popdown input[type="search"]')) return;
    clearTimeout(timer);
    timer = setTimeout(function () { runSearch(input); }, 180);
  });

  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('.search-popdown input[type="search"]')) loadAll();
  });

  function start() {
    injectDrawer();
    setupInputs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/* Lotte Laren — trackingpagina (ParcelPanel): verwerkingstekst verbergen, titel op één regel, groene knop */
(function () {
  if (location.pathname.indexOf('/apps/parcelpanel') === -1) return;
  var needles = ['werkdagen verwerkt', 'zodra je bestelling onderweg is'];
  var GREEN = '#18a76e', GREEN_DARK = '#13905e';

  function hideText() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node, hits = [];
    while ((node = walker.nextNode())) {
      var v = node.nodeValue || '';
      for (var i = 0; i < needles.length; i++) { if (v.indexOf(needles[i]) > -1) { hits.push(node); break; } }
    }
    hits.forEach(function (t) {
      var el = t.parentElement;
      if (!el) return;
      var own = el.textContent.trim();
      while (el.parentElement && el.parentElement !== document.body && el.parentElement.textContent.trim() === own) el = el.parentElement;
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function oneLineTitle() {
    document.querySelectorAll('h1, h2, h3, .hero__title, [class*="title"]').forEach(function (el) {
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt !== 'volg uw bestelling' && txt !== 'volg je bestelling') return;
      el.style.setProperty('white-space', 'nowrap', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('word-break', 'normal', 'important');
      if (window.innerWidth < 750) el.style.setProperty('font-size', 'clamp(18px, 6.6vw, 30px)', 'important');
      el.querySelectorAll('br').forEach(function (br) { br.style.display = 'none'; });
    });
  }

  function paint(el, color) {
    el.style.setProperty('background', color, 'important');
    el.style.setProperty('background-color', color, 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.style.setProperty('border-color', color, 'important');
    el.style.setProperty('color', '#ffffff', 'important');
  }

  function makeGreen(btn) {
    if (!btn || btn.getAttribute('data-ll-green') === '1') { if (btn) paint(btn, btn.matches(':hover') ? GREEN_DARK : GREEN); return; }
    btn.setAttribute('data-ll-green', '1');
    paint(btn, GREEN);
    btn.addEventListener('mouseenter', function () { paint(btn, GREEN_DARK); });
    btn.addEventListener('mouseleave', function () { paint(btn, GREEN); });
  }

  function greenButton() {
    /* Knoppen met de tekst 'Volgen' (ook als de tekst in een los <span> staat of via CSS in hoofdletters) */
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var t = (node.nodeValue || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t !== 'volgen' && t !== 'track') continue;
      var el = node.parentElement;
      if (!el || el.closest('.theme__header, .drawer, footer, nav')) continue;
      var btn = el.closest('button, a, [role="button"], [class*="btn"], [class*="button"], [class*="Btn"], [class*="Button"]') || el;
      makeGreen(btn);
    }
    document.querySelectorAll('input[type="submit"], input[type="button"]').forEach(function (inp) {
      var v = (inp.value || '').trim().toLowerCase();
      if (v === 'volgen' || v === 'track') makeGreen(inp);
    });
  }

  function clean() {
    if (!document.body) return;
    hideText();
    oneLineTitle();
    greenButton();
  }
  function go() {
    clean();
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(function () { clean(); });
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
      setTimeout(function () { mo.disconnect(); }, 30000);
    }
    setTimeout(clean, 1500);
    setTimeout(clean, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
